import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination, Navigation } from 'swiper/modules'
import { BannerOrigin, BannerType } from '@/app/entities/Banner'
import { useBanners } from '@/app/hooks/useBanners'
import { Spinner } from '@/view/components/ui/spinner'
import { ReferralCard } from './ReferralCard'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

const BannerSwiper = () => {
  const { banners, isLoading } = useBanners(
    BannerType.DASHBOARD_CARD,
    BannerOrigin.WEB,
  )

  return (
    <div className="relative w-full overflow-hidden rounded-lg max-sm:rounded-none">
      <Spinner className="inline h-4 w-4" show={isLoading} />
      {!isLoading && banners && (
        <>
          <div className="sm:w-full md:w-[448px]">
            <Swiper
              modules={[Autoplay, Pagination, Navigation]}
              spaceBetween={0}
              slidesPerView={1}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
                el: '.swiper-pagination',
                bulletActiveClass: 'bg-[#EA0356]',
                bulletClass:
                  'inline-block w-1.5 h-1.5 rounded-full bg-white/50 mx-1 cursor-pointer transition-all',
              }}
              navigation={{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              }}
              loop={true}
              className="rounded-lg max-sm:h-full max-sm:rounded-none"
            >
              <SwiperSlide className="block md:hidden">
                <div className="h-[180px] w-full overflow-hidden rounded-lg bg-white p-4">
                  <ReferralCard />
                </div>
              </SwiperSlide>

              {banners.banners.map((banner, index) => (
                <SwiperSlide key={index}>
                  <a
                    href={banner.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block"
                  >
                    <img
                      src={`${import.meta.env.VITE_CDN_URL}${banner.uri}`}
                      alt=""
                      className="h-auto max-h-[180px] w-full object-cover max-sm:h-full max-sm:max-h-none max-sm:rounded-none max-sm:object-contain md:rounded-lg"
                      loading="lazy"
                    />
                  </a>
                </SwiperSlide>
              ))}

              <div className="swiper-pagination !bottom-2"></div>
            </Swiper>
          </div>
        </>
      )}
    </div>
  )
}

export default BannerSwiper
